import { render, staticRenderFns } from "./IDCardFHIS.vue?vue&type=template&id=7ba3f0be&scoped=true&"
import script from "./IDCardFHIS.vue?vue&type=script&lang=js&"
export * from "./IDCardFHIS.vue?vue&type=script&lang=js&"
import style0 from "./IDCardFHIS.vue?vue&type=style&index=0&id=7ba3f0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba3f0be",
  null
  
)

export default component.exports